export const categoryBlocks = {
  desktop: {
    masthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead',
            class: 'u-center',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'mx-auto mb-3.5 u-center inline',
            cid: '924288',
            size: '970x250',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            style: 'top: 120px; left: 50px; width: 0; height: 0;',
            cid: '1023399',
            size: '160x600',
            fixed: true,
            className: 'fixed',
          },
        },
      ],
    },
    sidebarTop: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'text-center u-center',
            'unit-name': 'kategoriYaniTop',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'text-center',
            cid: '924290',
            size: '300x600',
          },
        },
      ],
    },
    sidebarBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'text-center',
            'unit-name': 'kategoriYaniBottom',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'text-center',
            cid: '924290',
            size: '300x600',
          },
        },
      ],
    },
    afterPagination: {
      ads: [
        {
          componentInfo: {
            type: 'IdealMedia',
            targeting: 'category',
            mode: 'feed',
          },
        },
      ],
    },
    kategoriTop: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'w-full text-center',
            'unit-name': 'kategoriTop',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'w-full text-center',
            cid: '924289',
            size: '336x280',
          },
        },
      ],
    },
    kategoriSponTop: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'w-full text-center',
            'unit-name': 'kategoriSponTop',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'w-full text-center',
            cid: '924289',
            size: '336x280',
          },
        },
      ],
    },
    kategoriMiddle1: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'w-full text-center',
            'unit-name': 'kategoriMiddle1',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'w-full text-center',
            cid: '924289',
            size: '336x280',
          },
        },
      ],
    },
    kategoriSponMiddle: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'w-full text-center',
            'unit-name': 'kategoriSponMiddle',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'w-full text-center',
            cid: '924289',
            size: '336x280',
          },
        },
      ],
    },
    kategoriMiddle2: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'w-full text-center',
            'unit-name': 'kategoriMiddle2',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'w-full text-center',
            cid: '924289',
            size: '336x280',
          },
        },
      ],
    },
    kategoriSponBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'w-full text-center',
            'unit-name': 'kategoriSponBottom',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'w-full text-center',
            cid: '924289',
            size: '336x280',
          },
        },
      ],
    },
    bodyBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'interstitial',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
  },
  mobile: {
    masthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead',
            class: 'u-center',
            lazy: false,
          },
        },
      ],
    },
    afterPagination: {
      ads: [
        {
          componentInfo: {
            type: 'IdealMedia',
            targeting: 'category',
            mode: 'feed',
          },
        },
      ],
    },
    kategoriTop: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'w-full text-center',
            'unit-name': 'kategoriTop',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'w-full text-center',
            cid: '924289',
            size: '336x280',
          },
        },
      ],
    },
    kategoriSponTop: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'w-full text-center',
            'unit-name': 'kategoriSponTop',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'w-full text-center',
            cid: '924289',
            size: '336x280',
          },
        },
      ],
    },
    kategoriMiddle1: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'w-full text-center',
            'unit-name': 'kategoriMiddle1',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'w-full text-center',
            cid: '924289',
            size: '336x280',
          },
        },
      ],
    },
    kategoriSponMiddle: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'w-full text-center',
            'unit-name': 'kategoriSponMiddle',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'w-full text-center',
            cid: '924289',
            size: '336x280',
          },
        },
      ],
    },
    kategoriMiddle2: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'w-full text-center',
            'unit-name': 'kategoriMiddle2',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'w-full text-center',
            cid: '924289',
            size: '336x280',
          },
        },
      ],
    },
    kategoriSponBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'w-full text-center',
            'unit-name': 'kategoriSponBottom',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'w-full text-center',
            cid: '924289',
            size: '336x280',
          },
        },
      ],
    },
    bodyBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'interstitial',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
  },
};
